export class BaseAnalyticsEvent {

}
